import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWaveLeaderboardRendererSet } from "../leaderboard/leaderboardRendererRegistry";
import { isApproveWave } from "@/helpers/waves/approve-wave.helpers";
interface WaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
  readonly onDropClick: () => void;
}
export const WaveSmallLeaderboardDrop: React.FC<WaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(9);
  const {
    drop,
    wave,
    isVotingClosed: t1,
    isVotingControlsLocked: t2,
    onDropClick
  } = t0;
  const isVotingClosed = t1 === undefined ? false : t1;
  const isVotingControlsLocked = t2 === undefined ? false : t2;
  const {
    SmallLeaderboardDrop
  } = useWaveLeaderboardRendererSet(wave.id);
  let t3;
  if ($[0] !== wave) {
    t3 = isApproveWave(wave);
    $[0] = wave;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== SmallLeaderboardDrop || $[3] !== drop || $[4] !== isVotingClosed || $[5] !== isVotingControlsLocked || $[6] !== onDropClick || $[7] !== t3) {
    t4 = <SmallLeaderboardDrop drop={drop} isApproveWave={t3} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} onDropClick={onDropClick} />;
    $[2] = SmallLeaderboardDrop;
    $[3] = drop;
    $[4] = isVotingClosed;
    $[5] = isVotingControlsLocked;
    $[6] = onDropClick;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};